<template lang="pug">
    SimpleBar.custom-scrollbar-control(data-simplebar-auto-hide='true' ref='scroll')
        slot
</template>

<script>
import SimpleBar from 'simplebar-vue'
import 'simplebar/dist/simplebar.css'
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'

const SCROLL_BOTTOM_DETECT_RANGE = 50

export default {
    name: 'custom-scrollbar-control',
    components: {
        SimpleBar,
    },
    data() {
        return {
            lastScrollBottomPos: null,
        }
    },
    mounted() {
        const simplebar = this.$refs.scroll.SimpleBar
        const scroll = simplebar.getScrollElement()

        this.$refs.scroll.$el.SimpleBar = simplebar

        scroll.addEventListener('scroll', () => {
            const top = scroll.scrollTop
            const height = scroll.scrollHeight - scroll.clientHeight

            const bottomPos = height - top

            if (bottomPos <= SCROLL_BOTTOM_DETECT_RANGE && this.lastScrollBottomPos > SCROLL_BOTTOM_DETECT_RANGE) {
                this.$emit('bottom')
                EventBus.$emit(Events.SCROLL_BOTTOM, {
                    scrollEl: this.$refs.scroll.$el,
                    scrollSelector: '.custom-scrollbar-control',
                })
            }

            this.lastScrollBottomPos = bottomPos
        })
    }
}
</script>
